import { newsService } from "@/api/news.service";
import { ref } from "vue";
import { NewsDetail } from "../News";
import { SearchHistory } from "@/classes/searchHistory";
import SearchHistoryService from "@/services/searchHistoryService";

export function useNewsOverview(){
    let newsCategories= ref<string[]>([]);
    let currentCategory= ref<string>("news");
    let displayNews = ref<NewsDetail[]>([]);
    let totalResults = ref<number>(0);
    let iframeFacebook = ref<string>("");
    let iframeInstagram = ref<string>("");
    const test= ref(0);


    async function initCategories(){
        const categories = await getCategories();
        newsCategories.value = categories;
    }
    async function getCategories():Promise<string[]>{
        return await newsService.getCategories();
    }
    function setCategory(category:string){
        currentCategory.value = category;
        test.value = test.value+1;
        //stuff laden oder auch nicht :D
    }
    async function initNews(){
        const useHistory = SearchHistoryService.Instance.checkHistoryMark();       
        await loadMore();
        if(useHistory){         
            await reloadSearchHistory();
        }
        
        iframeFacebook.value= await getIframe("newsFacebook");
        iframeInstagram.value= await getIframe("newsInstagram");

    }
    async function loadMore(keyword:string = ""){
        const results = await newsService.getNews(keyword, displayNews.value.length);
        displayNews.value = displayNews.value.concat(results.Results);
        totalResults.value = results.ResultTotalCount;
        test.value = test.value + displayNews.value.length;
    }
    async function getIframe(alias:string = ""){
        return await newsService.getIframe(alias);
    }
    async function setSearchHistory(id:string){
        const searchHistory = new SearchHistory({
            historyType: "news",
            id: id,
            itemCount: displayNews.value.length
        })
        SearchHistoryService.Instance.setSearchHistory(searchHistory);
    }
    async function reloadSearchHistory(): Promise<void>{
            //get
            const searchHistory = SearchHistoryService.Instance.getSearchHistory();
            //auswerten
            if(searchHistory && searchHistory.historyType && searchHistory.historyType=="news"){
                // const id = searchHistory.id;
                // const newsResult = await newsService.getNews("", 0, searchHistory.itemCount);
                const newsResult = await newsService.getNews("", 0, 10);
                if(newsResult){
                    displayNews.value = newsResult.Results;
                    totalResults.value = newsResult.ResultTotalCount;
                }                
            
                SearchHistoryService.Instance.removeSearchHistory();
        
                setTimeout(function(){                    
                    const clickedElement = document.getElementById(searchHistory.id);
                    if(clickedElement){
                        clickedElement.scrollIntoView({behavior: 'smooth'});
                    }
                }, 1000);
            }
        }

    return {
        currentCategory,
        newsCategories,
        displayNews,
        totalResults,
        iframeFacebook,
        iframeInstagram,
        test,
        initCategories,
        setCategory,
        initNews,
        loadMore,
        setSearchHistory
    };
}